const theme = {
  borderColor: 'rgb(204,204,204)',
  dividerColor: '#f2f2f2',
  selectedBorderColor: '#0058a3',
  hoverBorderColor: '#929292',
  events: {
    card: {
      background: 'rgb(245, 245, 245)',
    },
  },
  breakpoints: {
    sm: '@media screen and (max-width: 37.5rem)',
    md: '@media screen and (min-width: 37.5rem)',
    lg: '@media screen and (min-width: 56.25rem)',
    llg: '@media screen and (min-width: 68.75rem)',
    xl: '@media screen and (min-width: 75rem)',
    xxl: '@media screen and (min-width: 87.5rem)',
  },
};

export default theme;
